function LoginMemberCtrl($scope, $uibModalInstance, company_id, MemberLoginService) {
    'ngInject';

    $scope.title = 'Login';
    $scope.schema = {
        type: 'object',
        properties: {
            email: {type: 'string', title: 'Email'},
            password: {type: 'string', title: 'Password'}
        }
    };
    $scope.form = [{
        key: 'email',
        type: 'email',
        feedback: false,
        autofocus: true
    }, {
        key: 'password',
        type: 'password',
        feedback: false
    }];
    $scope.login_form = {};

    $scope.submit = function (form) {
        const options =
            {company_id};
        return MemberLoginService.login(form, options).then((member) => {
                member.email = form.email;
                member.password = form.password;
                return $uibModalInstance.close(member);
            }
            , err => $uibModalInstance.dismiss(err));
    };

    $scope.cancel = () => $uibModalInstance.dismiss('cancel');
}

export default LoginMemberCtrl;


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/login-member/login_member.controller.js